/* VITAOWN Noir — theme.js */
(function () {
  'use strict';

  /* Sticky header shadow on scroll */
  var header = document.querySelector('.site-header');
  if (header) {
    var onScroll = function () {
      header.classList.toggle('is-scrolled', window.scrollY > 8);
    };
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  /* Mobile menu */
  var toggle = document.querySelector('.menu-toggle');
  var nav = document.querySelector('.header-nav');
  if (toggle && nav) {
    toggle.addEventListener('click', function () {
      var open = nav.classList.toggle('is-open');
      toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
  }

  /* Scroll reveal */
  var revealEls = document.querySelectorAll('.reveal, .reveal-stagger');
  if ('IntersectionObserver' in window && revealEls.length) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          io.unobserve(entry.target);
        }
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
    revealEls.forEach(function (el) { io.observe(el); });
  } else {
    revealEls.forEach(function (el) { el.classList.add('is-visible'); });
  }

  /* Product gallery: thumbnails swap the main media */
  var gallery = document.querySelector('[data-product-gallery]');
  if (gallery) {
    var main = gallery.querySelector('.product-gallery-main');
    var thumbs = gallery.querySelectorAll('.product-thumb');
    thumbs.forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        thumbs.forEach(function (t) { t.classList.remove('is-active'); });
        thumb.classList.add('is-active');
        var type = thumb.getAttribute('data-media-type');
        var src = thumb.getAttribute('data-media-src');
        if (type === 'video') {
          main.innerHTML = '<video controls autoplay playsinline src="' + src + '"></video>';
        } else if (type === 'external_video') {
          main.innerHTML = '<div style="aspect-ratio:16/9;width:100%"><iframe src="' + src +
            '" style="width:100%;height:100%;border:0" allow="autoplay; encrypted-media" allowfullscreen></iframe></div>';
        } else {
          main.innerHTML = '<img src="' + src + '" alt="">';
        }
      });
    });
  }

  /* Account: show/hide password */
  document.querySelectorAll('[data-password-toggle]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var input = document.getElementById(btn.getAttribute('data-password-toggle'));
      if (!input) return;
      var showing = input.type === 'text';
      input.type = showing ? 'password' : 'text';
      btn.classList.toggle('is-active', !showing);
      btn.setAttribute('aria-label', showing ? 'Show password' : 'Hide password');
    });
  });

  /* Account: reveal the "forgot password" form */
  document.querySelectorAll('[data-recover-toggle]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var target = document.getElementById(btn.getAttribute('data-recover-toggle'));
      if (target) target.hidden = false;
    });
  });

  /* Newsletter: show a friendly note after Shopify redirects back */
  if (window.location.search.indexOf('customer_posted=true') !== -1) {
    var note = document.querySelector('[data-newsletter-success]');
    if (note) note.hidden = false;
  }
})();
